module.exports = __webpack_public_path__ + "img/s-light.2ec26190.svg";